import { Suspense } from "react"


import { ErrorBoundary } from "@/components/ErrorBoundary/ErrorBoundary.tsx"
import { Spinner } from "@/components/Spinner/Spinner.tsx"
import { ellipsize } from "@/styles/textStyles.ts"

import type { PropsWithChildren, ReactNode } from "react"

export const Loading = (props: LoadingProps) => {
  return (
    <ErrorBoundary renderError={props.renderError}>
      <Suspense fallback={props.renderLoading || <Spinner text={ellipsize("Loading")} />}>
        {props.children}
      </Suspense>
    </ErrorBoundary>
  )
}

type LoadingProps = PropsWithChildren & {
  renderLoading?: ReactNode
  renderError?: ReactNode
}
